import Detail from "features/Campaign/components/Detail";
import React from "react";

const CampaignDetail = () => {
  return <Detail />;
};

export default CampaignDetail;
